/* eslint-disable max-len */
import React, { FC } from 'react';
import {
    AccessoriesGarmentIcon,
    BeltGarmentIcon,
    FootScanIcon,
    FullbodyGarmentIcon,
    GlovesGarmentIcon,
    HeadgearGarmentIcon,
    JumperGarmentIcon,
    OtherGarmentIcon,
    OuterwearGarmentIcon,
    ShirtGarmentIcon,
    ShortsGarmentIcon,
    SkirtGarmentIcon,
    TrousersGarmentIcon,
    TshirtGarmentIcon,
} from '../IconSelectorComponent/IconSelectorComponent';

interface GarmentIconSelectorComponentProps {
    garment: string;
    color: string;
    fontSize: string;
}

const GarmentIconSelectorComponent: FC<GarmentIconSelectorComponentProps> = ({ garment, color, fontSize }) => {
    switch (garment) {
        case 'accessoriesGarment':
            return <AccessoriesGarmentIcon color={color} fontSize={fontSize} />;
        case 'beltGarment':
            return <BeltGarmentIcon color={color} fontSize={fontSize} />;
        case 'footwearGarment':
            return <FootScanIcon color={color} fontSize={fontSize} />;
        case 'fullbodyGarment':
            return <FullbodyGarmentIcon color={color} fontSize={fontSize} />;
        case 'glovesGarment':
            return <GlovesGarmentIcon color={color} fontSize={fontSize} />;
        case 'headgearGarment':
            return <HeadgearGarmentIcon color={color} fontSize={fontSize} />;
        case 'jumperGarment':
            return <JumperGarmentIcon color={color} fontSize={fontSize} />;
        case 'outerwearGarment':
            return <OuterwearGarmentIcon color={color} fontSize={fontSize} />;
        case 'shirtGarment':
            return <ShirtGarmentIcon color={color} fontSize={fontSize} />;
        case 'shortsGarment':
            return <ShortsGarmentIcon color={color} fontSize={fontSize} />;
        case 'skirtGarment':
            return <SkirtGarmentIcon color={color} fontSize={fontSize} />;
        case 'trousersGarment':
            return <TrousersGarmentIcon color={color} fontSize={fontSize} />;
        case 'tshirtGarment':
            return <TshirtGarmentIcon color={color} fontSize={fontSize} />;
        case 'otherGarment':
        default:
            return <OtherGarmentIcon color={color} fontSize={fontSize} />;
    }
};

export default GarmentIconSelectorComponent;
